import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Login from "views/auth/LDAP/LdapLogin";

export default function Auth() {
  return (
    <>
      <main>
        <section>
          <Switch>
            <Route path={`${process.env.PUBLIC_URL}/`} exact component={Login} />
            <Redirect from={`${process.env.PUBLIC_URL}/`} to="/" />
          </Switch>
        </section>
      </main>
    </>
  );
}
